import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { Input, Form, Button, Select, DatePicker } from 'antd'
import { injectIntl } from 'react-intl'
import AccountsAction from 'redux/accounts/actions'
import moment from 'moment'
import RenewalsAction from 'redux/renewals/actions'

const { Option } = Select

const mapStateToProps = ({ dispatch, accounts, renewals }) => ({
  dispatch,
  accounts,
  renewals,
})

const UpdateDomainName = ({ accounts, renewals, intl: { formatMessage } }) => {
  const dispatch = useDispatch()

  const onFinish = values => {
    dispatch({
      type: RenewalsAction.UPDATE_DOMAIN_INFO,
      payload: {
        id: renewals?.selectedData?.id,
        expiry_date: values?.currentrenewal.format('YYYY-MM-DD'),
      },
    })
  }

  const [form] = Form.useForm()

  useEffect(() => {
    dispatch({
      type: AccountsAction.LOAD_ALL,
    })
  }, [dispatch])

  // function disabledDate(current) {
  //   return current > moment().startOf('day')
  // }

  function disabledDatepast(current) {
    return current < moment().startOf('day')
  }

  const dateFormat = 'YYYY-MM-DD'
  const [valueone] = useState(new Date())
  const datevalue = moment(valueone).format('YYYY-MM-DD')
  const registereddatevalue = moment(renewals?.selectedData?.registered_date).format('YYYY-MM-DD')

  console.log('registereddatevalue', registereddatevalue)

  return (
    <div>
      <div className="card">
        <div className="card-body">
          <Form
            form={form}
            className="mb-4"
            layout="vertical"
            initialValues={{
              domainname: renewals?.selectedData?.domainname,
              started_at: moment(renewals?.selectedData?.registered_date).format('YYYY-MM-DD'),
              expiry_date: moment(renewals?.selectedData?.expiry_date).format('YYYY-MM-DD'),
              accounts_id: renewals?.selectedData?.accounts_id,
            }}
            onFinish={onFinish}
            hideRequiredMark
          >
            <div className="row">
              <div className="col-12 mt-3">
                <Form.Item
                  name="accounts_id"
                  label={formatMessage({ id: 'form.label.BusinessName' })}
                  rules={[
                    { required: true, message: formatMessage({ id: 'form.error.required' }) },
                  ]}
                >
                  <Select
                    placeholder={formatMessage({ id: 'form.placeholder.BusinessName' })}
                    size="large"
                    filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    disabled
                  >
                    {accounts?.accountlistinfo?.map(o => {
                      return (
                        <Option key={o.id} value={o.id}>
                          {o.business_name}
                        </Option>
                      )
                    })}
                  </Select>
                </Form.Item>
              </div>
              <div className="col-md-6">
                <Form.Item
                  name="domainname"
                  label={formatMessage({ id: 'form.label.domainname' })}
                  rules={[
                    { required: true, message: formatMessage({ id: 'form.error.required' }) },
                  ]}
                >
                  <Input
                    size="large"
                    placeholder={formatMessage({ id: 'form.placeholder.domainname' })}
                    maxLength={32}
                    style={{ textTransform: 'lowercase' }}
                    disabled
                  />
                </Form.Item>
              </div>
              <div className="col-md-6">
                <Form.Item
                  name="started_at"
                  label={formatMessage({ id: 'form.label.registeredat' })}
                >
                  <Input
                    size="large"
                    placeholder={formatMessage({ id: 'form.placeholder.started_at' })}
                    maxLength={32}
                    disabled
                  />
                </Form.Item>
              </div>

              <div className="col-md-6">
                <Form.Item
                  name="expiry_date"
                  label={formatMessage({ id: 'form.label.expiry_date' })}
                >
                  <Input
                    size="large"
                    placeholder={formatMessage({ id: 'form.placeholder.expiry_date' })}
                    maxLength={32}
                    disabled
                  />
                </Form.Item>
              </div>
              <div className="col-md-6">
                <Form.Item
                  name="currentrenewal"
                  label={formatMessage({ id: 'form.label.validtytill' })}
                >
                  <DatePicker
                    style={{ width: '100%' }}
                    size="large"
                    allowClear={false}
                    disabledDate={disabledDatepast}
                    selected={datevalue}
                    format={dateFormat}
                  />
                </Form.Item>
              </div>
            </div>

            <div className="row mt-1">
              <div className="col-md-12">
                <Form.Item className="text-right">
                  <Button
                    type="primary"
                    htmlType="submit"
                    size="large"
                    loading={renewals?.updating}
                  >
                    <strong>{formatMessage({ id: 'action.update' })}</strong>
                  </Button>
                </Form.Item>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </div>
  )
}

export default connect(mapStateToProps)(injectIntl(UpdateDomainName))
